<template>
    <div></div>
</template>

<script>
import { isEquipment } from '@/utils/browser'
import { fetchEvn, getQueryString } from '@/utils/utils'

export default {
    name: 'shortChain',
    data() {
        return {
            path: '',
            query: '',
            keyName: ''
        }
    },
    mounted() {
        this.init()
    },
    methods: {
        init(){
            this.path = getQueryString("path") || '';
            this.query = getQueryString("query") || '';
            this.keyName = this.path
            if (isEquipment().isPC) {
                this.$toast({
                    styles: {
                        maskColor: "rgba(0,0,0,0)",
                        background: "rgba(0,0,0,0.4)",
                        messageColor: "#fff"
                    },
                    content: '请使用移动端打开链接！',
                    duration: 2000
                })
                return
            }
            this.$ebLoading.show();
            this.handleTime()
        },
        handleTime(){
            let keyName = this.keyName
            let localData = localStorage.getItem(keyName) || '{}'
            let data = JSON.parse(localData) || {}
            
            try {
                if (Object.keys(data).length > 0) {
                    let { url , t } = data
                    if (new Date(t) < new Date()) {
                        this.getLink()
                    } else {
                        this.$ebLoading.hide();
                        window.location.href = url
                    }
                } else {
                    this.getLink()
                }
            } catch (error) {
                this.getLink()
            }
        },
        getLink() {
            let { path = '', query = '', keyName = '' } = this
            let params = { path, query }
            if (fetchEvn() === 'qa' || fetchEvn() === 'pre' || fetchEvn() === 'gr') {
                params.envVersion = 'develop'
            }
            this.$fetch({ url: "/ehs/tools/general/support/url-link", method: "post" }, params).then(res => {
                if (res.success) {
                    this.$ebLoading.hide();
                    let { urlLink, expireTime } = res.model
                    const data = { url: urlLink, t: expireTime }
                    localStorage.setItem(keyName, JSON.stringify(data))
                    window.location.href = urlLink
                } else {
                    this.$toast({
                        styles: {
                            maskColor: "rgba(0,0,0,0)",
                            background: "rgba(0,0,0,0.4)",
                            messageColor: "#fff"
                        },
                        content: res.errorMessage,
                        duration: 2000
                    })
                }
            }).finally(() => {
                this.$ebLoading.hide();
            })
        }
    }
}
</script>